// components/IncidentesSection.tsx

import { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';

import {
    DataTableColumn,
} from '@/presentation/components/common/DataTable';
import { IconButton } from '@/presentation/components/common/IconButton/IconButton';
import { ActionSection } from './ActionSection';
import { CreateDialog } from './CreateActionDialog';
import { DeleteActionDialog } from './DeleteActionDialog';
import { Form } from '@/presentation/components/Forms/Form/Form';
import { formatSmartDateTime } from '@/shared/utils/dateFormaters';
import { useIncidente } from '@/presentation/hooks/useIncidente';
import { IncidentesParamsDTO } from '@/application/dto/incidentes/IncidenteParamsDTO';

interface ActionItem {
    id: number;
    nombre: string;
    usuario: string;
    fecha: Date;
}

interface IncidenteSectionProps {
    IncidenteId: string;
}

export function IncidenteSection({
    IncidenteId
}: IncidenteSectionProps) {
    const [createOpen, setCreateOpen] =
        useState(false);

    const [deleteOpen, setDeleteOpen] =
        useState(false);

    const [selectedId, setSelectedId] =
        useState<number | null>(null);





    const {
        data: incidentes,
        loadAll: loadIncidentes,
        changeEstado
    } = useIncidente();
    const params: IncidentesParamsDTO = {
        id_visita: IncidenteId ? parseInt(IncidenteId) : undefined,
    };
    const {
        data: incidentesNuevos,
        loadAll: loadIncidentesNuevos,
    } = useIncidente();
    const params2: IncidentesParamsDTO = {
        pages: 1,
        sort: 'iniciado',
        order: 'desc',
        tipo: 4,
        id_visita: -1,
    };

    useEffect(() => {
        loadIncidentes(params);
        
    }, [loadIncidentes]);

    const data: ActionItem[] = incidentes.map(
        (incid) => ({
            id: incid.id,
            nombre: incid.equipo,
            usuario: `${incid.ubicacion} - ${incid.grupo}`,
            fecha: incid.iniciado,
        })
    );
    const options = incidentesNuevos.map(
        (incid) => ({
            value: incid.id,
            label: `${incid.id} - ${incid.equipo} - ${incid.ubicacion}`,
        }));




    const columns: DataTableColumn<ActionItem>[] =
        [
            {
                key: 'nombre',
                header: 'Equipo',
            },
            {
                key: 'usuario',
                header: 'Ubicación - Grupo',
            },
            {
                key: 'fecha',
                header: 'Fecha',
                render: (item) =>
                    formatSmartDateTime(item.fecha),
            },
            {
                key: 'eliminar',
                header: '',
                render: (item) => (
                    <IconButton
                        icon={<Trash2 size={30} />}
                        title="Eliminar"
                        color="danger"
                        onClick={() => {
                            setSelectedId(item.id);
                            setDeleteOpen(true);
                        }}
                    />
                ),
            },
        ];

    const handleOpenCreate = async () => {
        await loadIncidentesNuevos(params2);
        if (incidentesNuevos.length === 0) {
            alert('No hay incidentes nuevos para agregar');
            return;
        }

        setCreateOpen(true);
    };

    const handleCreate = async (
        values: Record<string, unknown>
    ) => {
        const incidente = {
            estado: 0,
            responsable: 0,
            tipo_responsable: 0,
            id_visita: IncidenteId ? parseInt(IncidenteId) : 0
        };
        await changeEstado(String(values.nombre), incidente);

        setCreateOpen(false);
        await loadIncidentes(params);
    };

    const handleDelete = async () => {
        if (selectedId === null) return;

        const incidente = {
            estado: 0,
            responsable: 0,
            tipo_responsable: 0,
            id_visita: -1
        };
        await changeEstado(String(selectedId), incidente);


        setDeleteOpen(false);
        setSelectedId(null);

        await loadIncidentes(params);
    };

    return (
        <>
            <ActionSection
                title="Incidentes"
                buttonLabel="Agregar un Incidente"
                data={data}
                columns={columns}
                emptyMessage="No hay Incidentes cargados"
                onCreate={handleOpenCreate}
            />

            <CreateDialog
                open={createOpen}
                title="Agregar Incidente"
                onClose={() => setCreateOpen(false)}
            >
                <Form
                    fields={[
                        {
                            name: "nombre",
                            type: "select",
                            label: "Incidente",
                            options: options,
                        },
                    ]}
                    submitLabel="Agregar"
                    onSubmit={handleCreate}
                />
            </CreateDialog>

            <DeleteActionDialog
                open={deleteOpen}
                title="Quitar Incidente"
                message="¿Seguro que quiere quitar el incidente?"
                onClose={() => setDeleteOpen(false)}
                onConfirm={handleDelete}
            />
        </>
    );
}